import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { PaymentTypeModel } from '@/models/tables/payment-type.model';
import { PaymentTypeService } from '@services/data-source-tables/payment-type.service';

@Component({
  selector: 'app-button-payment-type-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeletePaymentTypeComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private paymentTypeModel: PaymentTypeModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected paymentTypeService: PaymentTypeService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.paymentTypeModel = <PaymentTypeModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deletePaymentType) => {
      if (deletePaymentType) {
        this.paymentTypeService.deletePaymentType(this.paymentTypeModel.id).subscribe({
          next: () => {
            this.toastr.success('Tipo pagamento cancellato correttamente!');

            Registry.getInstance().get('PaymentTypeComponent').loadPaymentTypes();
          },
          error: (error) => {
            LoggerService.error('deletePaymentType failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione del Tipo pagamento.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questo tipo pagamento?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata questo Tipo pagamento non sarà più possibile recuperarlo.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
